<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.jcmj" alt>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Extrusion Mould</span>
          </u>
        </b>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        jcmj: require("../../../assets/img/common/jcmj.jpg")
      }
    };
  },

  components: {},
  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/jcmj.vue